import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { NotifierService } from 'angular-notifier';
import { CommonGridService } from 'src/app/shared/services/common-grid.service';
import { HomeService } from 'src/app/shared/services/home.service';
import { PerformanceTrackerService } from 'src/app/shared/services/performance-tracker.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-product-testing',
  templateUrl: './product-testing.component.html',
  styleUrls: ['./product-testing.component.scss']
})
export class ProductTestingComponent implements OnInit {
  pt_uuid: string;
  eventChart: any;
  chart = new Chart();
  eventsName: string[] = [];
  eventsCount: number[] = [];
  public launchedAt: string = "";

  public gridApiUrl:string = "/pt_user_responses"
  public type:string = "PT"
  // public type:string = "day"
  // public input_survey_id:number = 17650;
  public inputBody:any = {};
  constructor(private sidePanelService:SidePanelService,
    private performanceService: PerformanceTrackerService,
    public homeService: HomeService,
    private notifier: NotifierService,
    private activatedRoute: ActivatedRoute,
    public cgService:CommonGridService
  ) { 
    // this.inputBody = {
    //   pt_uuid: this.pt_uuid
    // };
    this.homeService.sidenav2Open.next(true);
    this.cgService.isCommonGridDataLoaded
        .subscribe((value: boolean)=> {
          this.onCommonGridDataLoaded();
        })  
  }

  ngOnInit(): void {
    // this.sidePanelService.initSideDrawer("PT");
    this.activatedRoute.params.subscribe((ptId) => { this.pt_uuid = ptId.id; });
    this.inputBody = {
      pt_uuid: this.pt_uuid,
      survey_id: 0,
      groups: ['events']
    };
    this.getPtDetails();
  }

  getPtDetails(){
    this.performanceService.getPtDetails(this.pt_uuid).subscribe((res:any)=>{
      if(res && res['status'] == 1){
        this.homeService.ptDetails = res['pt_details'];
        this.sidePanelService.initSideDrawer("PT");

        // this.cgService.gridDataContainer.forEach((data:any, index:number) => {
        //   if(data['overall']){
        //     // this.eventsName.push("event_"+(index+1));
        //     this.eventsName.push(data['events']);
        //     this.eventsCount.push(data['overall'] || 0);
        //   }
        // });
        // console.log('PT eventsName',this.eventsName);
        // console.log('PT eventsCount',this.eventsCount);
        // this.initChart();
      }else{
        this.notifier.notify('error', res['message'] || 'Something went wrong!');
      }
    })
  }

  onCommonGridDataLoaded(){
    // this.cgService.gridDataContainer.forEach((data:any, index:number) => {
    //       if(data['overall']){
    //         this.eventsName.push(data['events']);
    //         this.eventsCount.push(data['overall'] || 0);
    //       }
    //     });
    let overallResponses = this.cgService.gridDataContainer.find((data:any) => data['events'] == 'overall');
    console.log('overallResponses',overallResponses);
    Object.keys(this.cgService.gridHeaders).forEach((headerKey) => {
      if (headerKey != 'events') {
        console.log('Header Key:', headerKey," Value in overallResponses:", overallResponses[headerKey]);
        this.eventsName.push(this.cgService.gridHeaders[headerKey].name);
        this.eventsCount.push(overallResponses ? overallResponses[headerKey] || 0 : 0);
      }
    });
    this.launchedAt = this.cgService.gridResult?.launchedAt || "";
    // console.log('launchedAt',this.launchedAt);
    // console.log('PT gridResult',this.cgService.gridResult);
    // console.log('PT eventsName',this.eventsName);
    // console.log('PT eventsCount',this.eventsCount);
    this.initChart();
  }

  getLastResponse(){
    let responses = this.eventsCount && this.eventsCount.length > 0 ? this.eventsCount[this.eventsCount.length - 1] || 0 : 0;
    // let responses = this.homeService.ptDetails['events'] && this.homeService.ptDetails['events'].length > 0 ? this.homeService.ptDetails['events'][this.homeService.ptDetails['events'].length - 1].counts || 0 : 0;
    return responses;
  }

  initChart() {
      const chart = new Chart({
        chart: {
          type: 'line'
        },
        title: {
          text: ' '
        },
        xAxis: {
          categories: this.eventsName,
          lineColor: '#979797',
          lineWidth: 1,
        },
        yAxis: {
          title: { text: 'Response', style: { color: '#333333', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', fill: '#333333' } },
          lineColor: '#979797',
          lineWidth: 1,
          gridLineWidth: 0,
          minorGridLineWidth: 0,
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom'
        },
        tooltip: {
          formatter: function () {
            return 'Responses<br><b>' + this.y + '</b>';
          },
          useHTML: true,
        },
        credits: {
          enabled: false
        },
        series: [
          <Highcharts.SeriesColumnOptions>{
            name: 'Events',
            data: this.eventsCount
          }]
      });
      this.chart = chart;
    }
}
